import * as Types from '../Constants/AllConstants';

// Reducer for fetching all permissions (paginated)
export const GetPermissionsReducer = (
  state = { permissions: [], pages: 0, page: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.PERMISSIONS_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.PERMISSIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.pageable.pageNumber,
      };
    case Types.PERMISSIONS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer for fetching all permissions (non-paginated)
export const GetAllPermissionsReducer = (
  state = { permissions: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.PERMISSIONS_ALL_REQUEST:
      return { ...state, loading: true };
    case Types.PERMISSIONS_ALL_SUCCESS:
      return { ...state, loading: false, permissions: action.payload };
    case Types.PERMISSIONS_ALL_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer for fetching a specific permission by ID
export const GetPermissionByIdReducer = (
  state = { permission: {}, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.PERMISSION_DETAILS_REQUEST:
      return { ...state, loading: true };
    case Types.PERMISSION_DETAILS_SUCCESS:
      return { ...state, loading: false, permission: action.payload };
    case Types.PERMISSION_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer for creating a permission
export const CreatePermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PERMISSION_CREATE_REQUEST:
      return { loading: true };
    case Types.PERMISSION_CREATE_SUCCESS:
      return { loading: false, success: true, permission: action.payload };
    case Types.PERMISSION_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PERMISSION_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for creating multiple permissions
export const CreateBulkPermissionsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PERMISSION_BULK_CREATE_REQUEST:
      return { loading: true };
    case Types.PERMISSION_BULK_CREATE_SUCCESS:
      return { loading: false, success: true, permissions: action.payload };
    case Types.PERMISSION_BULK_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PERMISSION_BULK_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for updating a permission
export const UpdatePermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PERMISSION_UPDATE_REQUEST:
      return { loading: true };
    case Types.PERMISSION_UPDATE_SUCCESS:
      return { loading: false, success: true, permission: action.payload };
    case Types.PERMISSION_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PERMISSION_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for fetching client-accessible permissions
export const GetClientAccessiblePermissionsReducer = (
  state = { permissions: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.PERMISSIONS_CLIENT_ACCESSIBLE_REQUEST:
      return { ...state, loading: true };
    case Types.PERMISSIONS_CLIENT_ACCESSIBLE_SUCCESS:
      return { ...state, loading: false, permissions: action.payload };
    case Types.PERMISSIONS_CLIENT_ACCESSIBLE_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer for fetching customer-accessible permissions
export const GetCustomerAccessiblePermissionsReducer = (
  state = { permissions: [], loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.PERMISSIONS_CUSTOMER_ACCESSIBLE_REQUEST:
      return { ...state, loading: true };
    case Types.PERMISSIONS_CUSTOMER_ACCESSIBLE_SUCCESS:
      return { ...state, loading: false, permissions: action.payload };
    case Types.PERMISSIONS_CUSTOMER_ACCESSIBLE_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const DeletePermissionsReducer = (state = {}, action) => {
    switch (action.type) {
        case Types.PERMISSION_DELETE_REQUEST:
            return { loading: true };
        case Types.PERMISSION_DELETE_SUCCESS:
            return { loading: false, success: true };
        case Types.PERMISSION_DELETE_FAIL:
            return { loading: false, error: action.payload };
        case Types.PERMISSION_DELETE_RESET:
            return {};
        default:
            return state;
    }
};